import Courses from './Courses'

export default Courses
// eslint-disable-next-line import/export
export * from './Courses'
